import axios from "axios";

// constants
import { BASE_URL } from "src/utils/constants";

export const forgotPassword = (_email) => {
  const data = {
    emailId: _email,
  };

  const response = axios({
    method: "POST",
    url: `${BASE_URL()}/ForgetPassword`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

  return response;
};
